import "./App.css";
import { Route, Routes } from "react-router-dom";
import Store from "pages/Store";
import Review from "pages/Review";
import JournalReview from "pages/Journal";
import PaymentNotice from "pages/PaymentNotice";
import OtherTax from "pages/OtherTax";
import Header from "components/Header";
import Container from "components/common/Container";
import { MENU_TYPES } from "models/business.model";
import React from "react";
import { convertMenuTypeToStoreType, extractSubType } from "utils/converter";

function App() {
  return (
    <div className="App">
      <Header />
      <Container>
        <Routes>
          {MENU_TYPES.map((menuType) => (
            <React.Fragment key={menuType}>
              <Route
                key={`${menuType}-store`}
                path={`/${menuType}`}
                element={
                  <Store
                    storeType={convertMenuTypeToStoreType(menuType)}
                    subType={extractSubType(menuType)}
                  />
                }
              />
              <Route
                key={`${menuType}-review`}
                path={`/review/${menuType}/:id`}
                element={
                  // 일반전표는 편집 없이 조회·보류 처리·전송만 하므로 별도 화면을 쓴다
                  menuType === "journal" ? (
                    <JournalReview />
                  ) : (
                    <Review
                      storeType={convertMenuTypeToStoreType(menuType)}
                      subType={extractSubType(menuType)}
                    />
                  )
                }
              />
            </React.Fragment>
          ))}
          <Route path="/payment-notice" element={<PaymentNotice />} />
          <Route path="/other-tax" element={<OtherTax />} />
        </Routes>
      </Container>
    </div>
  );
}

export default App;
